app.service('editor',function($global, html){
	function init($parent = $('body')) {

		$('textarea[syntax][data-cm-version="v6"], textarea.syntax[data-cm-version="v6"]').each(function(){
			// codeMirror version 6.0
			const $textarea = $(this);

			let mode = $textarea.attr('syntax');
			// w aktualnej wersji html jest domyślnym trybem prezentacji (z supportem dla js i css w ramach tagów <script> i <style>)
			// poniższe jako TODO
			// if(mode === 'true' || mode === 'default' || mode === 'text/html'){
			// 	mode = 'mixedhtml';
			// } else if(mode === 'text/javascript'){
			// 	mode = 'javascript';
			// }

			console.log("#### CM6 INIT - admin ###");
			$textarea.hide();
			const $editor = $('<div class="cm6editor" />');
			const parentWidth = $textarea.parent().width();
			$textarea.wrap('<div/>').parent().width(parentWidth > 0 ? parentWidth : '100%');
			$textarea.parent().append($editor);
			const editorView = cm6.createEditorView(undefined, $editor[0]);
			// higlight background .cm-searchMatch-selected { background-color: #01FEFEBA; }
			const options = {
				readOnly: $textarea.closest('.read-mode').length > 0,
				firstLineNumber: $textarea.data('first-line-number') || 1
			};
			editorView.setState(cm6.createEditorState($textarea.val(), options));
	
			// update on focusout
			editorView.dom.addEventListener('focusout', () => {
				$textarea.val(editorView.state.doc);
			});

			function updateCurrentState() {
				const line = editorView.state.selection.ranges[0];
				editorView.setState(cm6.createEditorState(editorView.state.doc, options));
				editorView.dispatch({
					selection: { head: line.from, anchor: line.to },
					scrollIntoView: true,
				});
				editorView.focus();
			}
			function closeFullScreen() {
				$editor.removeClass("full-screen");
				$editor.parent().find('.close-full-screen').remove();
				$('html').removeClass('full-screen-editor');
				updateCurrentState();
			}

			// POC dla mechanizmu fullScreen
			const $fullScreenButton = $('<button type="button" class="full-screen-button">Powiększ</button>');
			$fullScreenButton[0].addEventListener("click", () => {
				const $closeButton=$('<button type="button" class="full-screen-button close-full-screen">Zamknij tryb pełnoekranowy</button>');
				$editor.prepend($closeButton);
				$closeButton[0].addEventListener("click", () => {
					closeFullScreen();
				});
				$editor.addClass("full-screen");
				$('html').addClass('full-screen-editor');
				updateCurrentState();
			});
			$textarea.parent().prepend($fullScreenButton);
			// zamykanie trybu pełnoekranowego po naciśnięciu ESCAPE
			editorView.dom.addEventListener('keydown', (event) => {
				if (event.key === 'Escape' && $editor.hasClass('full-screen')) {
					closeFullScreen();
				}
				if (event.key === 'F11') { // przełączanie trybu pełnoekranowego, dla sfocusowanego edytora
					event.preventDefault();
					if ($editor.hasClass('full-screen')) {
						closeFullScreen();
					} else {
						$fullScreenButton[0].click();
					}
				}
			});

			var inter;
			function isVisible() { 
				return parseInt($textarea.css('height')) > 0;
			}
			if (!isVisible()) {
				inter = setInterval(function () {
					if (isVisible()) {
						editorView.requestMeasure();
						clearInterval(inter);
					}
				}, 200);
			}
		});


		// OLD codeMirror version 5.+
		$('textarea[syntax]:not([data-cm-version="v6"]), textarea.syntax:not([data-cm-version="v6"])', $parent).each(function(){
			console.log("#### CM5 INIT - editor ###");
			var $textarea = $(this);

			var mode=$textarea.attr('syntax');
			if(mode==="true" || mode==="default"){
				mode="text/html";
			}

			var editor = CodeMirror.fromTextArea($textarea.get(0), {
				mode : mode,
				lineNumbers: true,
				readOnly: $textarea.closest('.read-mode').length>0,
				lineWrapping: true,
				foldGutter: true,
				firstLineNumber: $textarea.data('first-line-number')|| 1,
				gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
				extraKeys : {
					"Ctrl-Space" : "autocomplete",
					"F6": "findPersistent",
					"F11": function (cm) {
						html.toggle('full-screen-editor');
						cm.setOption("fullScreen", !cm.getOption("fullScreen"));
					},
					"Esc" : function(cm) {
						if (cm.getOption("fullScreen")) {
							html.remove('full-screen-editor');
							cm.setOption("fullScreen", false);
						}
					}
				}
			});
			editor.on("blur", function(cm) {
				$textarea.val(cm.getValue());
			});
			var inter;
			function isVisible() { 
				return parseInt($textarea.css('height')) > 0;
			}
			if (!isVisible()) {
				inter = setInterval(function () {
					if (isVisible()) {
						editor.refresh();
						clearInterval(inter);
					}
				}, 200);
			}

		});
	}
	return {
		init
	}
});
